import ScrollReveal from "../../components/ScrollReveal";
import { useLanguage } from "../../contexts/LanguageContext";

const Intro = () => {
  const { t } = useLanguage();
  return (
    <div
      id="inicio"
      className="scroll-mt-40 w-screen h-screen relative bg-cover bg-center md:bg-fixed flex items-center justify-center text-white"
      style={{ backgroundImage: "url('/images/construction.png')" }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#FFFFFF]/80 z-0" />

      {/* Content */}
      <div className="font-poppins text-center px-6 md:px-16 z-10">
        {/* Logo */}
        <ScrollReveal direction="up" delay={0.3} duration={1.0}>
        <img
          src="/images/logo_big.png"
          alt="Montelo Logo"
          className="mx-auto max-w-xs md:max-w-2xl mb-10"
        />
        </ScrollReveal>
        
        {/* Text */}
        <ScrollReveal direction="up" delay={0.6} duration={0.8}>
        <p className="text-[#282A2A] font-rockwell text-md mt-6 mb-10 text-center md:max-w-2xl">
          {t('intro.description')}
        </p>
        </ScrollReveal>
        {/* Button */}
        <ScrollReveal direction="right" delay={1.0} duration={0.8}>
        <a href="#contacto">
          <button className="bg-[#83C441] hover:bg-lime-600 text-white font-medium  py-3 px-5 rounded">
            {t('intro.contactButton')}
          </button>
        </a>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Intro;
